import { Component, OnInit } from '@angular/core';

declare function initPlugins();

@Component({
  selector: 'app-nopagefound',
  templateUrl: './nopagefound.component.html',
  styleUrls: ["./nopagefound.component.css"]
})
export class NopagefoundComponent implements OnInit {

  year:number = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
    initPlugins();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/components/nopagefound/nopagefound.component.ts